import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FileViewer,
  title: 'File Viewer',
  category: ComponentCategory.General,
};
